export default {
  SEARCH_CATALOG_KUSPIT_JOB_TYPE_QUERY: Symbol.for('SEARCH_CATALOG_KUSPIT_JOB_TYPE_QUERY'),
  CATALOG_KUSPIT_JOB_TYPE_REPOSITORY: Symbol.for('CATALOG_KUSPIT_JOB_TYPE_REPOSITORY'),
  CATALOG_KUSPIT_JOB_TYPE_STATE_MANAGER: Symbol.for('CATALOG_KUSPIT_JOB_TYPE_STATE_MANAGER'),
};
